var _circle, _circle2, _circle3, _circle4, _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgForgotPassword = function SvgForgotPassword(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 370,
    height: 370,
    viewBox: "0 0 370 370",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 250,
    r: 14
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 145,
    cy: 250,
    r: 14
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 250,
    r: 14
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 305,
    cy: 352,
    r: 12.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M305,328.67969a10.99992,10.99992,0,0,1-11-11V304.209A38.34931,38.34931,0,0,1,316.294,269.53516,27.00511,27.00511,0,1,0,278,245a11,11,0,0,1-22,0,49.17589,49.17589,0,0,1,15.57129-35.82617,48.57426,48.57426,0,0,1,36.88086-13.05469,49.00742,49.00742,0,0,1,17.05762,93.39258A16.28549,16.28549,0,0,0,316,304.209v13.47071A10.99992,10.99992,0,0,1,305,328.67969Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M348.09375,172.21387A48.94028,48.94028,0,0,0,303,141.5H265.5V85a80.5,80.5,0,0,0-161,0v56.5H67A48.55471,48.55471,0,0,0,18.5,190V316A48.55471,48.55471,0,0,0,67,364.5H263a8.5,8.5,0,0,0,0-17H67A31.5357,31.5357,0,0,1,35.5,316V190A31.5357,31.5357,0,0,1,67,158.5H303a31.80889,31.80889,0,0,1,29.293,19.9873,8.5003,8.5003,0,1,0,15.80078-6.27343ZM121.5,141.5V85a63.5,63.5,0,0,1,127,0v56.5Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgForgotPassword, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/forgotPassword.2b4631a6.svg";
export { ForwardRef as ReactComponent };